import axios from "axios";

const request = axios.create({
  // baseURL: ,
  baseURL:
    window.location.origin.indexOf("kuaifu.com") !== -1
      ? "https://login.kuaifu.com.cn"
      : "http://userlogin.71baomu.com",
  //代表请求超时的时间5s
  timeout: 5000,
});
//请求拦截器：在发请求之前，请求拦截器可以检测到，可以在请求发出去之前做一些事情
request.interceptors.request.use((config) => {
  //config:配置对象，对象里有一个属性很重要，headers请求头
  console.log(config);
  // config.headers["arg"] = "1111";
  // config["arg"] = "1111";
  return config;
});

//响应拦截器
request.interceptors.response.use(
  (res) => {
    //成功的回调函数：服务器响应数据回来以后，响应拦截器可以检测到，可以做一些事情

    return res.data;
  },
  (error) => {
    //响应失败的回调函数
    return Promise.reject(new Error("faile"));
  }
);

// 对外暴露
export default request;
